var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-menu",
            {
              ref: "menu",
              attrs: {
                "close-on-content-click": false,
                "nudge-right": 40,
                "return-value": _vm.contextModel,
                "max-width": "290px",
                "min-width": "290px",
                "offset-y": "",
                transition: "scale-transition"
              },
              on: {
                "update:returnValue": function($event) {
                  _vm.contextModel = $event
                },
                "update:return-value": function($event) {
                  _vm.contextModel = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-text-field",
                        _vm._g(
                          {
                            attrs: {
                              label: _vm.label,
                              placeholder: _vm.placeholder,
                              "prepend-icon": _vm.prependIcon,
                              readonly: ""
                            },
                            model: {
                              value: _vm.contextModel,
                              callback: function($$v) {
                                _vm.contextModel = $$v
                              },
                              expression: "contextModel"
                            }
                          },
                          on
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.contextDialog,
                callback: function($$v) {
                  _vm.contextDialog = $$v
                },
                expression: "contextDialog"
              }
            },
            [
              _vm.contextDialog
                ? _c("v-time-picker", {
                    attrs: { format: "24hr", "full-width": "" },
                    on: {
                      "click:minute": function($event) {
                        return _vm.$refs.menu.save(_vm.contextModel)
                      }
                    },
                    model: {
                      value: _vm.contextModel,
                      callback: function($$v) {
                        _vm.contextModel = $$v
                      },
                      expression: "contextModel"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }